export default __webpack_public_path__ + "static/font-8a0a057805ccdbb2eab3873b4dfd79f5.woff2";